export default __webpack_public_path__ + "static/media/tmobile_new.9e4a19b0.svg";